/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/cloud_transfer_medium'
export default icon
